import { ButtonProps, IconButton } from '@mui/material';
import { ChevronLeftIcon } from '~/icons';
import { ICON_SIZE, PRIMARY_COLOR } from './styles';

const PreviousPaginationButton = (props: ButtonProps) => {
  return (
    <IconButton {...props} sx={{ padding: '4px 4px 4px 0px', color: PRIMARY_COLOR }}>
      <ChevronLeftIcon style={{ width: ICON_SIZE, height: ICON_SIZE }} />
    </IconButton>
  );
};

export default PreviousPaginationButton;
